import * as React from 'react';
import {Container} from '../grid/container';
import './style.scss';
import {Translation} from "../../lang";

const pin = '/assets/src/components/outsourcing/Placeholder.svg';

export class OutsourcingComponent extends React.Component<any, any> {


    render() {
        return <Container className="outsourcingComponent">

            <div className="map-markers"/>

            <div className="container">
                <div className="col-12 d-flex justify-content-center justify-content-center">

                    <div
                        className="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 MS text-white text-center content-height">

                        <h1 className="fw-bold fst-italic text-nowrap">
                            Outs <span><img className="scale-animation" src={pin}/></span>urcing
                        </h1>
                        <p className="fst-italic"> {Translation.get('outsourcing.description')}
                        </p>
                        <br/>
                        <br/>
                        <br/>

                    </div>

                </div>
            </div>

        </Container>;
    }

}
